export default __webpack_public_path__ + "static/media/image-showroom.e3ba3144.png";